import { useState, useEffect, useRef } from 'react';
import {
  Box,
  ImageList,
  ImageListItem,
  Typography,
  ImageListItemBar,
  LinearProgress,
  CircularProgress,
  Paper,
} from '@mui/material';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import { useStore } from '../../utils/store';
import AddButtonComponent from '../../components/form/AddButtonComponent';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import CommonForm from '../../components/form/CommonForm';
import FormFieldData from '../../Models/FormFieldData';
import HttpServices from '../../services/HttpService';
import Constants from '../../utils/constants';
import { getFormatDate } from '../../utils/storageUtil';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import { useNavigate, useParams } from 'react-router-dom';
const ShiftPhotos: React.FC = ({}) => {
  const navigate = useNavigate();
  const isInitialLoad = useRef(true);
  const { crewId, shiftId } = useParams<{ crewId: any; shiftId: any }>();
  const [addNewDialogOpen, setAddNewDialogOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const { getAdmin } = useStore();
  const [itemData, setItemData] = useState<any[]>([]);
  const [currentImageUrl, setCurrentImageUrl] = useState<any>(null);
  const [currentImageDate, setCurrentImageDate] = useState<any>(null);
  const [currentImageNote, setCurrentImageNote] = useState<any>(null);
  const [imagealertOpen, setImagealertOpen] = useState<boolean>(false);

  type formData = {
    [k: string]: { required: boolean; value: any };
  };
  const [form, setForm] = useState<formData>({
    id: { required: false, value: null },
    notes: { required: true, value: '' },
    photo: { required: true, value: [] },
  });
  const clearForm = () => {
    setForm({
      id: { required: false, value: null },
      photo: { required: false, value: [] },

      notes: { required: false, value: '' },
    });

    setAddNewDialogOpen(false);
    fetchData();
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };
  const handleFileChange = (file: any) => {
    setForm((prev: any) => {
      return {
        ...prev,
        photo: { required: prev['photo'].required, value: file },
      };
    });
  };
  const handleRemove = (file: any) => {
    setForm((prev: any) => {
      return {
        ...prev,
        photo: { required: prev['photo'].required, value: [] },
      };
    });
  };
  const formFields: FormFieldData[] = [
    {
      name: 'notes',
      label: 'Notes',
      value: form.notes.value,
      minRows: 5,
      onChange: handleInputChange,
      isRequired: false,
      size: 12,
      type: 'textareaField',
    },
    {
      onChange: handleFileChange,
      value: form.photo.value,
      name: 'photo',
      isRequired: false,
      label: 'Photo',
      multiple: false,
      acceptFiles: 'image/*',
      type: 'file',
      size: 12,
      existingFiles: [],
      onRemoveFile: handleRemove,
      onRemoveExistingFile: (file: any) => {
        //handleRemoveFileUpdate(file, 'resource_product');
      },
      onOpenFile: (id) => {
        // handleDownloadFile(id);
      },
    },
  ];
  const handleSave = async () => {
    try {
      if (form.photo.value.length === 0) {
        setAlert({
          type: 'error',
          message: 'File is required',
          open: true,
        });
        return false;
      }
      const file: any = form.photo.value[0];
      if (file) {
        setIsLoading(true);

        const token = getAdmin();
        const apiUrl = `${Constants.apiURL}${Constants.photoURL}/shift/uploadSignedURL`;
        const signedData: any = await HttpServices.handlePresignedDocument(
          file,
          'shift',
          shiftId,
          token,
          apiUrl
        );
        console.log(`signedData`);
        console.log(signedData);
        console.log(`signedData`);
        const response: any = await HttpServices.post(
          Constants.apiURL + Constants.photoURL + '/shift?id=' + shiftId,
          {
            notes: form.notes.value,

            filePath: signedData.filePath,
            fileName: signedData.fileName,
          },
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        );

        setIsLoading(false);
        clearForm();

        console.log('POST Response:', response);
      }
    } catch (error: any) {
      console.error(`POST ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      if (itemData.length === 0) fetchData();
    }
  }, [shiftId]);
  const ImageDialog = () => {
    return (
      <Box style={{ width: '800px' }}>
        <Box>
          <img src={currentImageUrl} style={{ width: '100%' }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
          <Box sx={{ marginRight: '10px' }}>
            <Typography>Date</Typography>
            <Typography>{currentImageDate}</Typography>
          </Box>
          <Box sx={{ marginLeft: '10px' }}>
            <Typography>Note</Typography>
            <Typography>{currentImageNote}</Typography>
          </Box>
        </Box>
      </Box>
    );
  };
  const AddDialogContent = () => {
    return (
      <Box style={{ width: '800px' }}>
        <CommonForm
          singlePage={true}
          fields={formFields}
          onCancel={() => {}}
          formReset={clearForm}
          formTitle={'Add New Photo'}
          isLoading={isLoading}
          isUpdate={false}
          onSave={handleSave}
          actionButtonPosition="bottom"
        />
      </Box>
    );
  };
  const fetchData = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        `${Constants.apiURL}${Constants.photoURL}/shift`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          id: shiftId,
          search: '',
          limit: -1,
          offset: 0,
        }
      );
      if (response.success) {
        setItemData(response.data.paginateRecords);
      }
      console.log('GET Response:', response);
      setInProgress(false);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setInProgress(false);
    }
  };

  return (
    <Box className="main dashboardmain">
      <Box
        sx={{ width: '100%', padding: '20px' }}
        className="section dashboard"
      >
        <Box
          className="containergrid"
          sx={{
            padding: ' 16px',
          }}
        >
          {
            <Box>
              <div
                onClick={() => {
                  navigate(
                    '/schedules/crews-schedule/' + crewId + '/' + shiftId
                  );
                }}
                style={{
                  cursor: 'pointer',
                  display: 'inline-flex',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <UTurnLeftIcon
                  sx={{
                    transform: 'rotate(90deg)',
                    cursor: 'pointer',
                  }}
                />
                <Typography>Back</Typography>
              </div>
              <Paper sx={{ width: '100%', mt: 4 }} className="mt-4">
                <Box
                  sx={{
                    padding: '24px 16px 16px 16px',
                    mb: 2,
                    display: 'grid',
                    gap: '32px',
                    overflowX: 'scroll',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography
                      component={'h6'}
                      sx={{ mt: 4, fontWeight: '500' }}
                    >
                      {'Photos'}
                    </Typography>
                    {inProgress && (
                      <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <CircularProgress sx={{ color: 'rgb(0, 244, 255)' }} />
                      </Box>
                    )}
                    <AddButtonComponent
                      onClick={() => {
                        setAddNewDialogOpen(true);
                      }}
                      keyName="checkIcon"
                      label="Add Photo"
                    />
                  </Box>
                  <Box>
                    <ImageList sx={{ width: '100%' }} cols={4}>
                      {itemData.map((item: any) => (
                        <ImageListItem
                          key={item.document.filePath}
                          sx={{ cursor: 'pointer' }}
                          onClick={() => {
                            setCurrentImageUrl(
                              `${Constants.PHOTO_CDN_URL}/${item.document.filePath}`
                            );
                            setCurrentImageNote(item.notes);
                            setCurrentImageDate(getFormatDate(item.created));
                            setImagealertOpen(true);
                          }}
                        >
                          <img
                            srcSet={`${Constants.PHOTO_CDN_URL}/${item.document.filePath}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            src={`${Constants.PHOTO_CDN_URL}/${item.document.filePath}?w=248&fit=crop&auto=format`}
                            alt={item.notes}
                            loading="lazy"
                            style={{ cursor: 'pointer' }}
                          />
                          <ImageListItemBar
                            title={item.notes}
                            subtitle={
                              <span>{getFormatDate(item.created)}</span>
                            }
                            position="below"
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  </Box>
                </Box>
              </Paper>
            </Box>
          }
        </Box>
        <SimpleDialogComponent
          title={''}
          dialogContent={AddDialogContent()}
          open={addNewDialogOpen}
          handleClose={() => {
            setAddNewDialogOpen(false);
          }}
        />
        <SimpleDialogComponent
          title={'Photos'}
          dialogContent={ImageDialog()}
          open={imagealertOpen}
          handleClose={() => {
            setImagealertOpen(false);
          }}
        />
        <AlertMessageComponent
          type={alert.type}
          open={alert.open}
          handleClose={handleCloseAlert}
          message={alert.message}
        />
      </Box>
    </Box>
  );
};
export default ShiftPhotos;
